export const reportsConstants = { CLEAR_REPORT_SEARCH_DATA: "CLEAR_REPORT_SEARCH_DATA" };

export function clearReportSearchData() {
  return dispatch => {
    dispatch({
      type: reportsConstants.CLEAR_REPORT_SEARCH_DATA
    });
  };
}
